import {
  ReportVyhodnotenieMpkApi,
  VyhodnotenieMpkReportRequest as VyhodnotenieMpkReportRequestGenerated,
} from 'evidencna-aplikacia-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import { ClientResponse } from '../model/ClientResponse';
import { evidenciaPrefixPath } from './configuration/apiConfigurationConstants';
import { getFileName } from './exportClient';
import apiConfiguration from './configuration/apiConfiguration';
import VyhodnotenieMpkReportRequest from '../model/VyhodnotenieMpkReportRequest';
import { mapPripomienkaFilter } from './pripomienkaFilterClient';

const client = new ReportVyhodnotenieMpkApi(apiConfiguration(evidenciaPrefixPath));

interface ReportResponse {
  fileName: string;
  blob: Blob;
}

const map = (data: VyhodnotenieMpkReportRequest): VyhodnotenieMpkReportRequestGenerated => ({
  materialUuid: data.materialUuid,
  nahladVyhodnotenia: data.nahladVyhodnotenia,
  useFilter: data.useFilter,
  filterRequest: mapPripomienkaFilter(data.filterRequest),
});

// eslint-disable-next-line import/prefer-default-export
export const exportVyhodnotenieMpkReport = async (
  request: VyhodnotenieMpkReportRequest,
  options?: AxiosRequestConfig,
): Promise<ClientResponse<ReportResponse>> => {
  const {
    data,
    status,
    headers,
  } = await client.getReportVyhodnotenieMpk(
    map(request),
    { ...options, responseType: 'blob' },
  );
  const blob = data && new Blob([data]);
  const fileName = getFileName(headers);

  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};
